module.exports = __webpack_public_path__ + "img/Jump Casting62.895b58b1.jpg";